/**
 * Keeps every product card's per-model fit/stock line in sync with the
 * shopper's selected iPhone model, wherever a card renders (homepage rails,
 * collection/search grids, wishlist).
 *
 * DOM contract: `[data-model-note]` elements optionally carry
 * `data-model-map` (a JSON object of {optionValue: available} built server
 * side in snippets/product-card.liquid) plus `data-empty-text`,
 * `data-fits-template`, `data-sold-out-template`, and
 * `data-unlisted-template` (each with a literal "[model]" placeholder).
 * Cards for products with no model option (charms, straps) render static
 * "Fits every model" copy with no `data-model-map` and are left alone here.
 * Reads `vellum:selectedModel` from localStorage; listens for
 * `vellum:model-selected` (same-tab) and the `storage` event (other tabs).
 */
function updateModelCardNotes() {
  const model = window.localStorage.getItem('vellum:selectedModel');

  document.querySelectorAll('[data-model-note][data-model-map]').forEach((note) => {
    if (!model) {
      note.textContent = note.dataset.emptyText || note.textContent;
      note.classList.remove('product-card__model-note--fits', 'product-card__model-note--sold-out');
      return;
    }

    let availability;
    try {
      availability = JSON.parse(note.dataset.modelMap);
    } catch (error) {
      return;
    }

    const matchedKey = Object.keys(availability).find(
      (value) => value.toLowerCase() === model.toLowerCase()
    );

    if (matchedKey === undefined) {
      note.textContent = (note.dataset.unlistedTemplate || '').replace('[model]', model);
      note.classList.remove('product-card__model-note--fits');
      note.classList.add('product-card__model-note--sold-out');
    } else if (availability[matchedKey]) {
      note.textContent = (note.dataset.fitsTemplate || '').replace('[model]', model);
      note.classList.add('product-card__model-note--fits');
      note.classList.remove('product-card__model-note--sold-out');
    } else {
      note.textContent = (note.dataset.soldOutTemplate || '').replace('[model]', model);
      note.classList.add('product-card__model-note--sold-out');
      note.classList.remove('product-card__model-note--fits');
    }
  });
}

window.addEventListener('vellum:model-selected', updateModelCardNotes);
window.addEventListener('storage', (event) => {
  if (event.key === 'vellum:selectedModel') updateModelCardNotes();
});
window.addEventListener('vellum:cards-updated', updateModelCardNotes);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateModelCardNotes);
} else {
  updateModelCardNotes();
}
